import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SidebarService {
    private isOpenSubject = new BehaviorSubject<boolean>(false);
    private isMobileViewSubject = new BehaviorSubject<boolean>(window.innerWidth < 1024);

    isOpen$ = this.isOpenSubject.asObservable();
    isMobileView$ = this.isMobileViewSubject.asObservable();

    constructor() {
        this.checkViewport();
        window.addEventListener('resize', () => this.checkViewport());
    }

    private checkViewport() {
        const isMobile = window.innerWidth < 1024;
        const prev = this.isMobileViewSubject.value;
        this.isMobileViewSubject.next(isMobile);
        
        if (isMobile && prev !== isMobile) this.close();
        if (!isMobile && prev !== isMobile) this.open();
    }

    open() { this.isOpenSubject.next(true); }
    close() { this.isOpenSubject.next(false); }
    toggle() { this.isOpenSubject.next(!this.isOpenSubject.value); }

    autoToggle() {
        if (this.isMobileViewSubject.value) this.toggle();
    }
}
